import { render, staticRenderFns } from "./SidePanelCollection.vue?vue&type=template&id=4e9363a1&scoped=true"
import script from "./SidePanelCollection.vue?vue&type=script&lang=ts"
export * from "./SidePanelCollection.vue?vue&type=script&lang=ts"
import style0 from "./SidePanelCollection.vue?vue&type=style&index=0&id=4e9363a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9363a1",
  null
  
)

export default component.exports